import React from "react";
import { View, Dimensions, StyleSheet, TouchableOpacity, Image, StatusBar } from "react-native";
import { ThemeType } from "../../theme/theme";
import { useTheme } from "react-native-paper";
import { useSafeArea } from "react-native-safe-area-context";
import { Text } from "../../components/text/text";

interface CameraInfoViewProps {
  onClose: any;
}

export const CameraInfoView = ({ onClose }: CameraInfoViewProps) => {
  const theme = useTheme() as ThemeType;
  const styles = getStyles(theme);

  return (
    <View style={styles.container}>
      <StatusBar hidden={true} />
      <TouchableOpacity style={styles.crossContainer} onPress={onClose}>
        <Image style={styles.iconCross} source={require("../../../assets/icon-cross.png")} />
      </TouchableOpacity>
      <Image style={styles.bgImage} source={require("../../../assets/bg-check.png")} />
      <View style={styles.textContainer}>
        <Text
          style={styles.mobileCheckPaymentInstructionText}
          tx="homeStack.mobileCheckPaymentInstructions"
        />
        <Text style={styles.captureClearPhotoText} tx="homeStack.captureAClearPhoto" />
        <View style={styles.dotContainerTop}>
          <Image source={require("../../../assets/dot.png")} />
          <Text style={styles.dotText} tx="homeStack.separateTheCheck" />
        </View>
        <View style={styles.dotContainer}>
          <Image source={require("../../../assets/dot.png")} />
          <Text style={styles.dotText} tx="homeStack.placeOnSolid" />
        </View>
        <View style={styles.dotContainer}>
          <Image source={require("../../../assets/dot.png")} />
          <Text style={styles.dotText} tx="homeStack.makeSureTheImageIncludes" />
        </View>
      </View>
    </View>
  );
};

const getStyles = (theme: ThemeType) => {
  const { width, height } = Dimensions.get("window");
  const { spacing, fontSize, colors, iconSize } = theme;
  const insets = useSafeArea();

  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.darkBg,
    },
    crossContainer: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      bottom: spacing.large,
      right: spacing.medium,
      height: spacing.huge,
      width: spacing.huge,
      borderRadius: spacing.large,
      backgroundColor: colors.translucent,
      borderColor: colors.white,
      borderWidth: 1,
    },
    iconCross: {
      height: iconSize.smaller + iconSize.tiny,
      width: iconSize.smaller + iconSize.tiny,
      resizeMode: "contain"
    },
    bgImage: {
      position: "absolute",
      bottom: insets.bottom,
      left: 52,
      right: 109,
      transform: [{ rotate: "90deg" }],
      resizeMode: "contain",
    },
    mobileCheckPaymentInstructionText: {
      fontSize: fontSize.larger + fontSize.tiny,
      fontWeight: "500",
      color: colors.white,
      marginLeft: spacing.largerPlus,
      marginStart: spacing.largerPlus,
    },
    captureClearPhotoText: {
      fontSize: fontSize.large,
      fontWeight: "600",
      color: colors.white,
      marginTop: spacing.huge,
      marginLeft: spacing.largerPlus,
      marginStart: spacing.largerPlus,
    },
    dotContainerTop: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      marginTop: spacing.medium,
      marginLeft: spacing.huge,
      marginStart: spacing.huge,
      width: 2 * width,
    },
    dotContainer: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      marginTop: spacing.large,
      marginLeft: spacing.huge,
      marginStart: spacing.huge,
      width: 2 * width,
    },
    dotText: {
      fontSize: fontSize.large - 1,
      color: colors.white,
      marginLeft: spacing.small,
      marginStart: spacing.small,
      fontWeight: "normal",
    },
    textContainer: {
      transform: [{ rotate: "90deg" }],
      top: width / 4 - spacing.massive,
      marginTop: insets.top + spacing.small,
      marginLeft: spacing.large,
      marginStart: spacing.large,
    },
  });
};
